import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { ButtonMenuItemComponent } from '../../../shared/components/button-menu-item/button-menu-item.component';
import { ContextMenuComponent } from '../../../shared/components/context-menu/context-menu.component';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { ButtonDirective } from '../../../shared/directives/button.directive';
import { CapitalizePipe } from '../../../shared/pipes/capitalize.pipe';
import { AccessItemCtaComponent } from '../access-item-cta/access-item-cta.component';
import { AccessItemHeaderComponent } from '../access-item-header/access-item-header.component';
import { AccessItemComponent } from '../access-item/access-item.component';

@Component({
  selector: 'app-theme-text-transform-item',
  imports: [
    AccessItemComponent,
    AccessItemHeaderComponent,
    AccessItemCtaComponent,
    ContextMenuComponent,
    ButtonDirective,
    SvgComponent,
    ButtonMenuItemComponent,
    CapitalizePipe,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './theme-text-transform-item.component.html',
  styleUrl: './theme-text-transform-item.component.scss',
})
export class ThemeTextTransformItemComponent {
  textTransform = input.required<string>();
  textTransformChange = output<string>();
  transforms = ['none', 'capitalize', 'uppercase', 'lowercase'];
}
